import api from './api';

export default {
  getAll() { return api.get('/services'); },
  getById(id: number) { return api.get(`/services/${id}`); },
  create(data: any) { return api.post('/services', data); },
  update(id: number, data: any) { return api.put(`/services/${id}`, data); },
  delete(id: number) { return api.delete(`/services/${id}`); }
};
